import React, { useState } from "react";
import { StyledButtonLogs } from '../../styles';
import LogsModal from './LogsModal';
import { blockchainService } from "../../../../../../services/blockchainService";

const LogsMerge = ({ projectId, modeloDocumentId, modeloTopicId }) => {
  const token = sessionStorage.getItem('Authorization');
  const headers = { Authorization: `Bearer ${token}` };
  const [merges, setMerges] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [show, setShow] = useState(false);

  const fetchMerges = async () => {
    setLoading(true);
    setError("");

    try {
      const params = {};
      if (projectId) params.projectId = projectId;
      if (modeloDocumentId) params.modeloDocumentId = modeloDocumentId;
      if (modeloTopicId) params.modeloTopicId = modeloTopicId;

      console.log("📦 Parâmetros para requisição:", params);

      // 🔹 Usa blockchainService em vez de axios
      const responseData = await blockchainService.getMergeHistory(params, headers);

      console.log("📄 Histórico de merges:", responseData);
      setMerges(responseData);
      setShow(true); // Exibe após carregar
    } catch (err) {
      setError("Erro ao buscar histórico de merges");
      console.error("❌ Erro ao carregar merges:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <StyledButtonLogs onClick={fetchMerges} style={{ cursor: "pointer" }}>
        Logs
      </StyledButtonLogs>

      <LogsModal
        show={show}
        onClose={() => setShow(false)}
        merges={merges}
      />
    </div>
  );
};

export default LogsMerge;
